function checkSellingPlans(cart) {
  console.log("🟡 --- Checking cart items selling plans:");
  let sellingPlans = new Set();

  cart.items.forEach((item, index) => {
    console.log(`🟡 --- Item ${index + 1}: ${item.title}`);
    console.log(
      `🟡 --- Selling Plan: ${
        item.selling_plan_allocation?.selling_plan.name || "No selling plan"
      }`
    );
    console.log(
      `🟡 --- Selling Plan ID: ${
        item.selling_plan_allocation?.selling_plan.id || "N/A"
      }`
    );
    if (item.selling_plan_allocation) {
      sellingPlans.add(item.selling_plan_allocation.selling_plan.id);
    }
  });

  if (sellingPlans.size > 1) {
    console.warn(
      "🟡 --- Warning: Multiple different selling plans detected in cart"
    );
  } else if (sellingPlans.size === 1) {
    console.log("🟡 --- All items have the same selling plan");
  } else {
    console.log("🟡 --- No selling plans in cart");
  }
}

function updatecart() {
  var giftProductId = $("body").data("gift_product");
  $.ajax({
    url: "/cart?view=cst",
    type: "GET",
    response: "html",
    async: false,
    success: function (data) {
      $(
        ".sidebar_area .side_bar_drawer__scrollable,.sidebar_area .total_price,.sidebar_count"
      ).empty();
      var items = $(data).find("#CartPageForm [data-products]").html();
      if (!items) {
        $(".sidebar_area").addClass("empty");
        items =
          '<div class="empty-cart-mssg"><div class="title">Empty Cart, Full of Fresh, Goal-Crushing Potential.</div><div><a href="/collections/all-meals" class="btn btn-outline btn--no-animate js-no-transition">Explore the menu</a></div></div>';
      } else {
        $(".sidebar_area").removeClass("empty");
      }

      $(".sidebar_area .side_bar_drawer__scrollable").html(items);
      var subtotal = $(data).find(".cart__footer [data-subtotal]").html();
      $(".sidebar_area .total_price").html(subtotal);
      var price_per = $(data).find(".cart__footer [data-price-per]").html();
      if (!price_per) price_per = "0";
      $(".sidebar_area .price-per").html(price_per);
      var count = $(data).find(".cart__footer [data-totalitems]").html();
      if (!count) count = 0;
      var ict = $("#ictct").val();

      // Check if the gift product is in the cart items
      var hasGiftProduct = items.includes(giftProductId);

      // Set the required count based on the presence of the gift product
      var requiredCount = hasGiftProduct ? 8 : 7;

      var mcount = count + "/" + ict;
      $("#cart_count").html(count);
      count = parseInt(count);
      ict = parseInt(ict);
      mcount = "Choose " + requiredCount + "+ Meals"; // Update the message to reflect the required count
      $(".sidebar_area .sidebar_count").html(mcount);

      if (count >= requiredCount) {
        $(".sidebar_count").css("display", "none");
        $(".sidebar_checkout,.meals_check").css("display", "block");
      } else {
        $(".sidebar_checkout,.meals_check").css("display", "none");
        $(".sidebar_count").css("display", "block");
      }

      $(".cart-link__bubble").text(count);
      $("#remaining-meal").text(" " + (requiredCount - count));

      if (count > 0) {
        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
      } else {
        $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
      }

      if (count < requiredCount) {
        $(".sidebar_checkoutmeal").addClass("hide");
        $(".cart_count-view").addClass("hide");
        $(".sidebar_counter").removeClass("hide");
        $(".cart_count-choose").removeClass("hide");

        $(".fast-checkout,.custom_area").css("display", "none");
        $(".orderline span")
          .attr("class", "")
          .addClass("count-" + count);
        $(".count-left").text(requiredCount - count);
        $(".sidebar_min .mssg").text("Choose " + requiredCount + "+ meals");
        $(".sidebar_area").removeClass("minimum");
        // $(".one-item-purchase-meals.custom_area").css("display", "block");
      } else if (count >= requiredCount) {
        if (!$(".orderline span").hasClass("full")) {
          $(".sidebar_min .mssg").text("Subscribe for free shipping");
          $(".orderline span").attr("class", "").addClass("full");
        }
        $(".sidebar_area").addClass("minimum");
        $(".sidebar_checkoutmeal").removeClass("hide");
        $(".cart_count-view").removeClass("hide");
        $(".sidebar_counter").addClass("hide");
        $(".cart_count-choose").addClass("hide");
        $(".fast-checkout").css("display", "block");
        // $(".one-item-purchase-meals.custom_area").css("display", "block");
      }

      function isEmpty(el) {
        return !$.trim(el.html());
      }
      if (isEmpty($(".sidebar_area .total_price"))) {
        $(".sidebar_area .total_price").html("$0.00");
      }
      $.getJSON("/cart.js", function (cart) {
        var vl = cart.item_count;
        if (vl == 0) {
          $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
        } else {
          $(".cart-link__bubble").addClass("cart-link__bubble--visible");
        }

        // Add selling plan check
        checkSellingPlans(cart);

        const SkioBABDiscount = document.querySelectorAll("skio-bab-discount");
        if (SkioBABDiscount.length) {
          SkioBABDiscount.forEach((el) => (el.productCount = cart.item_count));
        }
      });
      // Update shipping price to match meal count
      if (count >= 10) {
        $("#shiprice").html(
          '<span class="free" style="color: #ea473e; font-weight: bold">FREE!</span>'
        );
      } else {
        $("#shiprice").html('<span class="not-free">$9.95</span>');
      }
    },
  });
}
// $(document).ready(function () {
//   updatecart();
// });

$(".custom-switch #switch").on("change", function () {
  if ($(this).is(":checked")) {
    $(".sidebar_area").addClass("sub");
  } else {
    $(".sidebar_area").removeClass("sub");
  }
  toggle_btn_updatecart();
});
$(document).on("click", ".schedule_btns button", function () {
  $(this).addClass("act").siblings().removeClass("act");
  $(this).addClass("selected").siblings().removeClass("selected");
});
$(document).on(
  "click",
  ".header-item--icons .js-drawer-open-cart",
  function (e) {
    const mq = window.matchMedia("(min-width: 1151px)");
    if ($("body").hasClass("template-collection") && mq.matches) {
      return false;
    }
    e.preventDefault();
    $("html").addClass("drawer-active");
    $(".sidebar_area").addClass("openbar");
    $(".cart-overlay").addClass("active");
    $("#cart_count-cust").css("display", "none");
    $(".cart_count-choose").css("display", "none");
  }
);
$(document).on("click", ".close_menu", function () {
  $("body").removeClass("custom_cart_bnd");
  $(".sidebar_area").removeClass("openbar");
  $(".cart-overlay").removeClass("active");
  $("#cart_count-cust").css("display", "flex");
  $(".cart_count-choose").css("display", "flex");

  $("html").removeClass("drawer-active");
});

// ATC function for product grid on menu page

$(document).on(
  "click",
  ".catc-btn, .product-single__form .add-to-cart",
  function (e) {
    var quantity = 1;

    if ($(this).hasClass("add-to-cart")) {
      e.preventDefault();
      quantity = $(".js-qty__num").val();
      $(".sidebar_area").addClass("openbar");
      $(".cart-overlay").addClass("active");
    }

    var pid = $(this).attr("data-prd");
    var sel1 = $(this).attr("data-selid1");
    var sel2 = $(this).attr("data-selid2");
    var ele = $(this).find(".unused-btn").html("Added");

    var datatest = {
      data: {
        quantity: quantity,
        id: pid,
        selling_plan: sel1,
        properties: {
          _selling_1: sel1,
          _selling_2: sel2,
          _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
          _dynamicBoxIndex: 0,
        },
      },
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: pid,
        selling_plan: sel1,
        properties: {
          _selling_1: sel1,
          _selling_2: sel2,
          _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
          _dynamicBoxIndex: 0,
        },
      },
      dataType: "json",
      success: function (response) {
        // Log the response to see the final selling plan details
        console.log(
          "🟡 --- Item added to cart with response:",
          JSON.stringify(response, null, 2)
        );
        $(".modal__close").click();
        updatecart();
      },
      error: function (error) {
        // Log any errors that occur
        console.error("Error adding item to cart:", error);
      },
    });
    setTimeout(function () {
      $(ele).html("Add to Cart");
    }, 1000);
  }
);

//Reduce qty side cart on menu collection

$(document).on("click", ".reduce-qty", function () {
  var pid = $(this).attr("data-prd");
  var cartItemKey = $(this).attr("data-key");
  var sel1 = $(this).attr("data-selid1");
  var sel2 = $(this).attr("data-selid2");
  var bd = $(this).attr("data-rc");

  var qty = parseInt($(this).prev().val());

  $(".collection_overlay").css("display", "none");

  if (qty > 0) {
    qty = qty - 1;
    $(this).prev().val(qty);
  }
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: qty,
      id: cartItemKey,
      properties: {
        _selling_1: sel1,
        _selling_2: sel2,
        _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
        _dynamicBoxIndex: 0,
      },
    },
    dataType: "json",
    success: function () {
      console.log(
        "🟡 --- updated qty with attributes: ",
        qty,
        cartItemKey,
        sel1,
        sel2,
        "505328c4-d2f4-4a62-95fe-dee3b342d073",
        0
      );

      updatecart();
    },
  });
});

//Add qty side cart on menu collection
$(document).on("click", ".add-qty", function () {
  var qty = parseInt($(this).prev().prev().val());
  qty = qty + 1;
  $(this).prev().prev().val(qty);

  var pid = $(this).attr("data-prd");
  var cartItemKey = $(this).attr("data-key");
  var sel1 = $(this).attr("data-selid1");
  var sel2 = $(this).attr("data-selid2");
  var bd = $(this).attr("data-rc");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: qty,
      id: cartItemKey,
      selling_plan: sel1,
      properties: {
        _selling_1: sel1,
        _selling_2: sel2,
        _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
        _dynamicBoxIndex: 0,
      },
    },
    dataType: "json",
    success: function () {
      updatecart();
    },
  });
});

$(document).on("click", ".remove-prd", function () {
  var pid = $(this).attr("data-prd");
  var cartItemKey = $(this).attr("data-key");
  var sel1 = $(this).attr("data-selid1");
  var sel2 = $(this).attr("data-selid2");
  var bd = $(this).attr("data-rc");
  $(".collection_overlay").css("display", "none");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: 0,
      id: cartItemKey,
      properties: {
        _selling_1: sel1,
        _selling_2: sel2,
        _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
        _dynamicBoxIndex: 0,
      },
    },
    dataType: "json",
    success: function () {
      console.log(
        "🟡 --- removed item with attributes: ",
        "quantity: ",
        0,
        "id: ",
        cartItemKey,
        "selling_plan: ",
        sel1,
        "dynamicBoxId: ",
        "505328c4-d2f4-4a62-95fe-dee3b342d073",
        "dynamicBoxIndex: ",
        0
      );
      updatecart();
    },
  });
});

$("#clear-cart-btn").on("click", function () {
  $.ajax({
    async: false,
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      updatecart();
      $("#cart_count").html("0");
    },
    dataType: "json",
  });
});
$(document).on("click", ".meals_check", function () {
  $(".popUp-modal").show();
  $("body").css("overflow", "hidden");
});

$(".cart-overlay").on("click", function () {
  $(".sidebar_area").removeClass("openbar");
  $(".cart-overlay").removeClass("active");
  $("#cart_count-cust").css("display", "flex");
  $("html").removeClass("drawer-active");
});
